exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".finaBtnStyle {\r\n    background-color: #3f5c94 !important\r\n}", ""]);

